import { createContext } from 'react';

/**
 * Whether a navigation is loading its route, for layouts that set `handle.ownsRouteLoader` and
 * draw their own overlay instead of the app-wide one. False outside the app's data router.
 */
export const RouteLoadingContext = createContext(false);
